import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { MapPin } from 'lucide-react';

export default function Deliveries() {
  return (
    <div className="space-y-6" data-testid="deliveries-page">
      <div>
        <h1 className="font-heading text-3xl font-bold text-[#022C22]">Despacho</h1>
        <p className="text-[#64748B] mt-1">Gestiona las entregas pendientes</p>
      </div>

      <Card className="border border-[#E2E8F0] shadow-sm">
        <CardHeader>
          <CardTitle className="font-heading text-xl font-bold flex items-center gap-2">
            <MapPin size={24} />
            Mapa de Entregas
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="bg-[#F8F9FA] rounded-md p-12 text-center" data-testid="map-placeholder">
            <MapPin size={48} className="mx-auto text-gray-400 mb-4" />
            <p className="text-gray-600 mb-2">Vista de mapa con OpenStreetMap</p>
            <p className="text-sm text-gray-500">Aquí se mostrarían las ubicaciones de los clientes con entregas pendientes</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}